<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-16 09:43:46
 * @LastEditTime: 2021-01-20 11:37:53
 * @LastEditors: daikeyi
 -->
<template>
<div id="page_Container">
    <div class='page shopCart'>
        <h5 class='cartTopFixed clearfix' v-if='listShow && isHaveFinished'>
            <span class='pull-left'>共{{quantity}}件宝贝</span>
            <span type="text" @click='allDelete' class='text'>{{text}}</span>
        </h5>
        <div id="main-container">
            <!-- 购物车商品 -->
            <div class='cartList'>
                <div class='cartListBox' :class="{flexClass:!listShow,s5Style:spShow}">
                    <van-checkbox-group v-model="result" @change='changeResult'>
                        <template v-for="item in cartList">
                            <div :key="item.id" class='list' v-if='listShow'>
                                <div v-if='item.activityFlag === "true"' >
                                    <van-row>
                                        <van-col span="18">
                                            <!-- <p v-show="result.length>0">
                                                <span class='spanStyle'>{{item.activityTypeDesc}}</span>
                                                <span>{{item.preferentialDesc}}</span>
                                            </p> -->
                                            <p v-show="result.length>0">
                                                <span class='spanStyle'>{{item.activityTypeDesc}}</span>
                                                <span>{{item.curMeetDesc}}</span>
                                            </p>
                                            <p v-show="result.length === 0">
                                                <span class='spanStyle'>{{item.activityTypeDesc}}</span>
                                                <span>{{item.meetDesc}}</span>
                                            </p>
                                        </van-col>
                                        <van-col span="6" class='colGroup'>
                                            <p @click='fullActivitysClick(item)'>
                                                <span class='spanStyleRight'>查看活动</span>
                                                <van-icon class='arrowCart' name="arrow" />
                                            </p>
                                        </van-col>
                                    </van-row>
                                </div>
                                <van-swipe-cell :right-width="100" v-for="itemProduct in item.memberShippingCartList" :key='itemProduct.id'>
                                    <div class='checkBoxBox'>
                                        <van-checkbox :name="itemProduct.id" label-disabled :disabled='itemProduct.isCC'>
                                            <div>
                                                <van-card>
                                                    <template slot='thumb'>
                                                        <div class='boxImg' @click='openDetails(itemProduct)'>
                                                            <img :src="itemProduct.productImage" />
                                                        </div>
                                                    </template>
                                                    <template slot='title'>
                                                        <p @click='openDetails(itemProduct)' class='title'>{{itemProduct.productName}}</p>
                                                    </template>
                                                    <template slot='desc'>
                                                        <p class='desc' @click='openDetails(itemProduct)'>规格：{{itemProduct.specificationValue}}</p>
                                                        <div class="box-wrapper">
                                                            <div class='boxLeft'>
                                                                <p class='xg' v-if='itemProduct.isMarketable === 2'>库存量{{itemProduct.inventory}}件</p>
                                                                <p class='xj' v-if='itemProduct.isMarketable === 1'>商品已下架</p>
                                                                <P class='s5span'>¥{{itemProduct.productPrice}}</P>
                                                            </div>
                                                            <div class='descBox clearfix'>
                                                                <p><van-stepper :disabled='itemProduct.isMarketable === 1 || itemProduct.inventory === 0' integer async-change @change='onChangeNum(itemProduct,$event, vm)' size="small" :min='1' :max='itemProduct.buyLimit && itemProduct.buyLimit <= itemProduct.inventory ? itemProduct.buyLimit : itemProduct.inventory === 0 ? itemProduct.quantity : itemProduct.inventory' v-model="itemProduct.quantity" /></p>
                                                                <p class='xg' v-if='itemProduct.buyLimit'>限购{{itemProduct.buyLimit}}件</p>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </van-card>
                                            </div>
                                        </van-checkbox>
                                    </div>
                                    <span slot="right" class='yr' @click='moveClick(itemProduct)'>移入<br/>收藏夹</span>
                                    <span slot="right" class='delete' @click='deleteClick(itemProduct)'>删除</span>
                                </van-swipe-cell>
                            </div>
                        </template>
                        <listBottom v-if='finishedOk' class='listBottomStyle'></listBottom>
                        <div class='divBox'>

                        </div>
                    </van-checkbox-group>

                    <div v-if='!listShow' class='listShowStyle'>
                        <img :src="noCartUrl" alt="">
                        <p>再忙，也要记得给自己买点什么~</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="submit-bar" v-if='listShow && isHaveFinished'>
            <van-row>
                <van-col span="6">
                    <div class='checkAll'>
                        <van-checkbox v-model="checked" :disabled='disabledCheck' @change='changeAll' class='allText'>全选</van-checkbox>
                    </div>
                </van-col>
                <van-col span="18">
                    <div class='checkBtn' v-if='!clickChange'>
                        <van-row>
                            <van-col span="14">
                                <div class='divSb'>
                                    <div class='divBoxje'>
                                        <p>合计：<span class="je">¥{{moneyNew.productAmount ? moneyNew.productAmount.toFixed(2) : '0.00'}}</span></p>
                                        <p>优惠：<span class="je">¥{{moneyNew.preferentialAmount ? moneyNew.preferentialAmount : '0.00'}}元</span></p>
                                    </div>
                                    <!-- <div class='divBoxje'>
                                       合计：
                                    </div> -->
                                </div>
                                <!-- <span class='btnSpan1'>合计：¥{{moneyNew.productAmount ? moneyNew.productAmount : '0.00'}}</span>
                                <span class='btnSpan2'>优惠{{moneyNew.preferentialAmount ? moneyNew.preferentialAmount : '0.00'}}元</span> -->
                            </van-col>
                            <van-col span="10">
                                <van-button round type="danger" class='submitStyle' @click='settlementClick' :disabled='disabledBtn'>结算({{idStr.length === 0 ? 0 : idStr.split(',').length}})</van-button>
                            </van-col>
                        </van-row>
                    </div>
                    <p class='checkBtnDelete' v-if='clickChange'>
                        <van-button class='yrBtn' round @click='clickMoveAllBtn' :disabled='disabledBtn'>移入收藏夹</van-button>
                        <van-button class='deleteBtn' round @click='clickDeleteAllBtn' :disabled='disabledBtn'>删除</van-button>
                    </p>
                </van-col>
            </van-row>

        </div>
        <van-dialog
            v-model="show"
            title="数量不能大于库存数量"
            >
        </van-dialog>
    </div>
</div>
</template>
<script>
import { Toast } from 'vant';
import { debounce, toastLoading, clearToastLoading } from '@/utils/base/utils';
import {
    mapActions
} from 'vuex';
import listBottom from '@/components/common/listBottom';
export default {
    name: 'shoppingcart',
    components: {
        listBottom
    },
    data() {
        return {
            finishedOk: false,
            show: false,
            vm: this,
            isHaveFinished: false,
            result: [],
            deleteImg: require('../assets/img/myCenter/deleteCart.png'),
            commodityUrl: require('../assets/img/myCenter/commodity.png'),
            noListUrl: require('../assets/img/myCenter/noList.png'),
            noCartUrl: require('../assets/img/myCenter/noCart.png'),
            num: 0,
            money: 568.8,
            checked: false,
            text: '管理',
            clickChange: false,
            cartList: [],
            listShow: true,
            idStr: '',
            disabledBtn: false,
            sum: 0,
            disabledCheck: false,
            spShow: false,
            checkList: [],
            isUpdate: false,
            resultNew: [],
            resultListId: [],
            yhMoney: 0,
            isHaveTwo: true,
            moneyNew: {},
            quantity: 0,
            isall: false
        };
    },
    esvReady() {
        // 获取屏幕宽度
        const htmlWidth =
            document.documentElement.clientWidth || document.body.clientWidth;
        // 针对5s做出的适配
        htmlWidth === 320 ? (this.spShow = true) : (this.spShow = false);
    },
    esvShow() {
        document.title = '购物车';
        this.setAddressBeginId('-1'); // 清空地址id
        this.queryMemberShippingCartList();
        let goodsId;
        let list;
        this.ESVStorage.getSavedValue('goodsId', (data) => {
            goodsId = data;
        });
        this.ESVStorage.getSavedValue('list', (data) => {
            list = data;
        });
        list = list !== '' ? list : [];
        this.ESVStorage.clearSavedValue();

        this.ESVStorage.putSavedValue('goodsId', goodsId);
        this.ESVStorage.putSavedValue('cTabIndex', 2);
        this.ESVStorage.putSavedValue('list', list);
    },
    methods: {
        ...mapActions(['setAddressBeginId']),
        queryMemberShippingCartList() {
            const ths = this;
            const params = {

            };
            const arr = [];

            ths.$doRequest(
                {
                    url: '/cart/queryMemberShippingCartList',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.isHaveFinished = true;
                    ths.cartList = data.result.resultList;
                    let a = 0;
                    if (ths.cartList) {
                        ths.cartList.forEach((item, index) => {
                            item.memberShippingCartList.forEach((itemNew, index) => {
                                if (itemNew.isMarketable === 2) {
                                    a = a + 1;
                                }
                            });
                        });
                        if (a > 0) {
                            ths.disabledCheck = false;
                        }
                        if (a === 0) {
                            ths.disabledCheck = true;
                        }
                    }

                    ths.quantity = data.result.quantity;
                    if (ths.cartList.length > 0) {
                        ths.disabledBtn = false;
                        ths.finishedOk = true;
                        ths.listShow = true;
                        ths.checkList = [];
                        ths.resultListId = [];
                        let aLeg = 0;
                        data.result.resultList.forEach((item, index) => {
                            item.memberShippingCartList.forEach(
                                (itemNew, index) => {
                                    if (itemNew.quantity > itemNew.inventory || itemNew.isMarketable === 1) {
                                        itemNew.isCC = true;
                                    } else {
                                        aLeg++;
                                        itemNew.isCC = false;
                                        ths.resultListId.push(itemNew.id);
                                        ths.checkList.push(itemNew);
                                    }
                                }
                            );
                        });

                        ths.$nextTick(() => {
                            ths.result = ths.resultNew;
                        });
                        ths.checkList.forEach((item, index) => {
                            ths.result.forEach((itemNew, index) => {
                                if (itemNew === item.id) {
                                    arr.push(item);
                                }
                            });
                        });
                        if (arr.length > 0) {
                            ths.calculationAmount(arr);
                        }

                        // 新增更新全选得时候
                        ths.result.length === aLeg
                            ? (ths.checked = true)
                            : (ths.checked = false);
                        if (ths.isall) {
                            ths.result = [];
                        }
                    } else {
                        ths.disabledBtn = true;
                        ths.listShow = false;
                        ths.finishedOk = false;
                        // 为空时不可选中 金额为0
                        ths.sum = 0;
                        ths.checked = false;
                        ths.disabledCheck = true;
                    }
                },
                function(data) {
                    console.log(data);
                    if (data.responseCode === '10001003') {
                        ths.esvOpenPage({ name: 'OPLogin' });
                    }
                }
            );
        },
        // 把meet数据塞入cartList
        addMeetDescToCartList() {
            for (let i = 0; i < this.cartList.length; i++) {
                const cartListItem = this.cartList[i];
                if (cartListItem.activityFlag === 'true' && this.moneyNew.resultList) {
                    for (let j = 0; j < this.moneyNew.resultList.length; j++) {
                        const moneyNewItem = this.moneyNew.resultList[j];
                        if (Number(moneyNewItem.activityId) === Number(cartListItem.activityId)) {
                            cartListItem.curMeetDesc = moneyNewItem.meetDesc;
                        }
                    }
                }
            }
        },
        allDelete() {
            this.clickChange = !this.clickChange;
            if (this.clickChange) {
                this.text = '完成';
            } else {
                this.text = '管理';
            }
        },
        deleteClick(item) {
            this.isall = false;
            this.deleteMemberShippingCart(item.id, 1);
        },
        moveClick(item) {
            this.isall = false;
            this.moveCollection(item.id, 1);
        },
        moveCollection(id, type) {
            const ths = this;
            const params = {
                membershippingCartIdList: id
            };
            ths.$doRequest(
                {
                    url: '/cart/moveCollection',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.moneyNew = {};
                    if (type === 1) {
                        ths.result.forEach((item, index) => {
                            if (id === item) {
                                ths.result.splice(index, 1);
                            }
                        });
                    } else {
                        ths.idStr = '';
                    }
                    ths.queryMemberShippingCartList();
                }
            );
        },
        changeAll(all) {
            if (all) {
                this.result = this.resultListId;
            } else {
                if (this.result.length > 0) {
                    this.checked = false;
                    if (this.result.length === this.checkList.length) {
                        this.sum = 0;
                        this.result = [];
                    }
                } else {
                    this.sum = 0;
                    this.result = [];
                }
            }
        },
        fullActivitysClick(item) {
            const ths = this;
            ths.$doRequest(
                {
                    url: '/activity/queryActivityById',
                    params: {
                        id: item.activityId

                    },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.ESVStorage.putSavedValue(
                        'activityDetails',
                        data.result
                    );
                    ths.esvOpenPage('OPFullActivitys');
                }
            );
        },
        changeResult(result) {
            let idStr = '';
            const arr = [];
            let sum = 0;
            if (result.length <= 0) {
                this.moneyNew = {};
            }
            this.resultNew = result;

            this.checkList.forEach((item, index) => {
                this.resultNew.forEach((itemNew, index) => {
                    if (itemNew === item.id) {
                        arr.push(item);
                    }
                });
            });

            if (arr.length > 0) {
                this.calculationAmount(arr);
            }
            arr.length === this.checkList.length
                ? (this.checked = true)
                : (this.checked = false);

            arr.forEach((item, index) => {
                idStr += item.id + ',';
                sum = sum + item.productPrice * item.quantity;
            });
            idStr = idStr.substr(0, idStr.length - 1);
            this.idStr = idStr;
            this.sum = sum;
        },
        // 请求优惠元
        calculationAmount(arr) {
            const ths = this;
            let membershippingCartIdList = '';

            arr.forEach((item, index) => {
                membershippingCartIdList += item.id + ',';
            });
            membershippingCartIdList = membershippingCartIdList.substring(
                0,
                membershippingCartIdList.length - 1
            );
            const params = {
                membershippingCartIdList: membershippingCartIdList
            };
            ths.$doRequest(
                {
                    url: '/cart/calculationAmount',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                (data) => {
                    this.moneyNew = data.result;
                    this.addMeetDescToCartList();
                }
            );
        },
        clickMoveAllBtn() {
            this.isall = true;
            if (this.idStr.length <= 0) {
                Toast('请选择商品');
                return false;
            }
            this.moveCollection(this.idStr, 2);
        },
        clickDeleteAllBtn() {
            this.isall = true;
            if (this.idStr.length <= 0) {
                Toast('请选择商品');
                return false;
            }
            this.deleteMemberShippingCart(this.idStr, 2);
        },
        deleteMemberShippingCart(id, type) {
            const ths = this;
            const params = {
                membershippingCartIdList: id
            };
            ths.$doRequest(
                {
                    url: '/cart/deleteMemberShippingCart',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.moneyNew = {};
                    if (type === 1) {
                        ths.result.forEach((item, index) => {
                            if (id === item) {
                                ths.result.splice(index, 1);
                            }
                        });
                    } else {
                        ths.idStr = '';
                    }
                    ths.queryMemberShippingCartList();
                }
            );
        },
        settlement(orderJsonList) {
            const ths = this;
            const params = {
                orderJsonList: orderJsonList,
                usePointFlag: 1
            };
            if (JSON.parse(orderJsonList).length <= 0) {
                Toast('请勾选要结算的商品');
                return false;
            }
            ths.$doRequest(
                {
                    url: '/order/settlement',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    const result = data.result;
                    result.orderRespDTOList.forEach((item, index) => {
                        console.log(item.value.activeList);

                        const activeList = item.value.activeList && JSON.parse(item.value.activeList);
                        if (activeList && activeList.length > 0) {
                            activeList.push({ activityId: -1,
                                activityTitle: '不使用活动',
                                activityType: 4
                            });
                        }
                        item.value.activeList = JSON.stringify(activeList);
                    });
                    ths.ESVStorage.putSavedValue('requireInfo', result);
                    ths.ESVStorage.putSavedValue('requireInfoall', result);
                    const arr = [];
                    ths.ESVStorage.putSavedValue('invoiceArr', arr);
                    ths.ESVStorage.putSavedValue('submitType', '2');
                    ths.esvOpenPage({ name: 'OPConfirmOrder' });
                }
            );
        },
        settlementClick() {
            const ths = this;
            const orderJsonList = [];
            ths.checkList.forEach((item, index) => {
                ths.result.forEach((itemNew, index) => {
                    if (itemNew === item.id) {
                        orderJsonList.push({
                            productId: item.productId,
                            skuCode: item.skuCode,
                            quantity: item.quantity,
                            spreadingCode: item.spreadingCode || ''
                        });
                    }
                });
            });
            ths.settlement(JSON.stringify(orderJsonList));
        },
        openDetails(item) {
            if (item.isMarketable === 1) {
                return false;
            }
            this.ESVStorage.putSavedValue('goodsId', item.productId);
            this.esvOpenPage({
                name: 'OPGoodsdetail',
                params: { goodsId: item.productId }
            });
        },
        onChangeNum: debounce((i, num, vm) => {
            vm.changeNum(i, num);
        }, 500),
        changeNum(i, num) {
            const ths = this;
            if (num === 0) {
                i.quantity = 1;
                return false;
            }
            if (num > i.inventory) {
                if (i.inventory === 0) {
                    return false;
                } else {
                    ths.show = true;
                    // setTimeout(function() {
                    // ths.show = false;
                    // }, 2500);
                    i.quantity = i.inventory;
                    return false;
                }
            }
            const params = {
                id: i.id,
                productId: i.productId,
                skuCode: i.skuCode,
                quantity: num
            };
            ths.$doRequest(
                {
                    url: '/cart/updateMemberShippingCart',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.isUpdate = true;
                    ths.queryMemberShippingCartList();
                },
                function(erro) {
                    i.quantity = num;
                }
            );
        },
        gobuy() {
            Toast('提交订单');
        },
        onClickLeft() {},
        onClickRight() {}
    }
};
</script>
<style lang="scss" scoped>
.spanStyle {
    background: #ee2e50;
    color: white;
    padding: 3px 8px;
    border-radius: 5px;
    margin-right:5px;
}
.text{
    text-decoration: none;
}
.spanStyleRight {
    color: #ee2e50;
}
.arrowCart {
    color: #ee2e50;
    margin-top: 3px;
    float: right;
    margin-left: 5px;
}
//5s样式适配
.cartList {
    height: 100%;
    .cartListBox {
        height: 100%;
        /deep/ .van-checkbox-group {
            .list:first-child{
                margin-top:0;
            }
        }
    }
    .van-swipe-cell__right {
        width: 67px;
        background: red;
        color: #fff;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    h5 {
        // background: #fff;
        padding: 0 12px;
        text-align: right;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 99;
        .van-button--default {
            border-color: #fff;
        }
    }
    .list {
        margin-top: 12px;
        padding: 12px;
        background: #fff;
        /deep/ .van-swipe-cell{
            border-bottom:1px solid #E3E2E2;
        }
        /deep/ .van-swipe-cell:last-child{
            border: none;
        }
        .checkBoxBox {
            padding: 12px 0 1px 0;
            /deep/ .van-card{
                background: #fff;
                .van-card__thumb {
                    position: absolute;
                }
            }
            .van-checkbox__label {
                width: 90%;
            }
            .desc {
                color: #999;
                min-height: 40px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                // margin-top:5px;
            }
            .boxLeft {
                float: left;
                .s5span {
                    color: #ee2e50;
                    font-size: 12px;
                }
                .xj{
                    color:#999;
                }
            }
            .descBox {
                text-align: right;
                .xg{
                    padding-right:23px;
                    color: #ee2e50;
                }
            }
        }
    }
}
.submit-bar {
    padding: 0 12px;
    height: 50px;
    line-height: 50px;
    background: #fff;
    position: absolute;
    bottom: 50px;
    left: 0;
    width: 100%;
    .checkAll {
        float: left;
        width: 60%;
        min-width: 70px;
    }
    .checkBtn {
        text-align: right;
        .van-button {
            width: 100%;
            background: #ee2e50;
            height: 35px;
            line-height: 35px;
        }
        span {
            // color: #ee2e50;
            // margin-right: 10px;
        }
    }
    .checkBtnDelete {
        width: 100%;
        float: right;
        text-align: right;
        .yrBtn {
            width: 95px;
            background: #fff;
            height: 35px;
            line-height: 35px;
            font-size:12px;
            border-color: #FD9404;
            color: #FD9404;
            margin-right:5px;
        }
        .deleteBtn {
            width: 95px;
            background: #fff;
            height: 35px;
            line-height: 35px;
            font-size:12px;
            border-color: #ee2e50;
            color: #ee2e50;
        }
    }
}

.cartTopFixed {
    padding:0 12px;
    width: 100%;
    background: rgb(243,243,243);
    text-align: right;
    line-height: 44px;
    .van-button {
        border: none;
    }
    span{
        color:#666;
        font-weight: 500;
        font-size:14px;
    }
    span:nth-child(2){
        // text-decoration: underline;
    }
}
.colGroup {
    text-align: right;
}
.xg {
    color: #f8c367;
}
.divBox {
    height: 110px;
    background: #f2f2f2;
    width: 100%;
}
.divSb{
    padding-top:6px;
}
.divBoxje{
    float:right;
    height:25px;
    line-height: 25px;
    margin-right: 8px;
    text-align: left;
    p:nth-child(1){
        line-height:25px;
        font-size:14px;
        margin-bottom: 3px;
    }
    p:nth-child(2){
        line-height:0;
        font-size: 12px;
    }
}
.je{
    color: #ee2e50;
}
.listShowStyle {
    text-align: center;
    img {
        width: 203px;
    }
    p {
        padding-top: 20px;
        text-align: center;
        color: #999;
        font-size: 14px;
    }
}
.btnSpan1 {
    display: block;
    height: 13px;
    line-height: 30px;
    font-size: 14px;
}
.btnSpan2 {
    display: block;
    height: 13px;
    line-height: 37px;
    font-size: 12px;
}
.allText {
    font-size: 14px;
}
.shopCart {
    height: 100%;

}
.shopCart .van-card__content .title {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical;
    line-height: 16px;
    margin-bottom:5px;
}
.cartList .list .checkBoxBox .desc {
    color: #999;
    min-height: 34px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 16px;
}
.submitStyle{
    margin-top:7px;
}
.list{
    /deep/ .van-row{
        border-bottom: 1px solid #E3E2E2;
        padding-bottom: 10px;
    }
    /deep/ .van-swipe-cell {
        padding-bottom: 10px;
    }
}
/deep/ .van-checkbox__icon--round {
    .van-icon {
        border-color:#aaa;
    }
}
/deep/ .van-checkbox__icon--checked {
    .van-icon {
        border-color: #EE2E50!important;
    }
}
// .listBottomStyle{
//     margin-bottom:50px;
// }
</style>
